<section class="eligibility header" [class.video-url]="!!videoUrl">
  <video-background *ngIf="videoUrl" [posterImage]="posterImage" [videoURLMP4]="videoUrl"> </video-background>

  <div class="container main" [ngClass]="{ 'no-eligibility': !(showDbsEligibility || showTMRef1Eligibility) }">
    <mat-card
      *ngIf="showDbsEligibility || showTMRef1Eligibility"
      class="checker"
      [ngClass]="{ 'dark-mode': darkMode, 'checker--alternative': showTMRef1Eligibility || showDbsEligibility }"
    >
      <h1>{{ (customVariables$ | async)?.product_name }}</h1>
      <h4>
        {{ (customVariables$ | async)?.eligibility_page_instruction1 }}
        <a *ngIf="(customVariables$ | async)?.eligibility_page_info_link" (click)="openDialog()">{{
          (customVariables$ | async)?.eligibility_page_info_link
        }}</a>
      </h4>

      <tm-ref1-eligibility-check
        *ngIf="showTMRef1Eligibility"
        (changedEligibilityForm)="setFormData($event)"
      ></tm-ref1-eligibility-check>

      <dbs-eligibility-check
        *ngIf="showDbsEligibility"
        (changedEligibilityForm)="setFormData($event)"
      ></dbs-eligibility-check>

      <re-captcha
        *ngIf="captchaLanguage && enableRecaptcha"
        size="invisible"
        site_key="6LeS4KsUAAAAAH5apd5lwvbc8WLWNgi16d2CprVP"
        language="{{ captchaLanguage }}"
        [tabindex]="-1"
        (captchaResponse)="getCaptchaToken($event)"
      >
      </re-captcha>

      <!--condition operand to come from site config variable-->
      <button
        mat-raised-button
        id="mid_button_register"
        tabindex="0"
        class="check-btn"
        aria-label="Check eligibility and register"
        [color]="data?.buttonColor"
        [disabled]="eligibilityForm.invalid"
        (click)="enableRecaptcha ? checkEligibility() : getCaptchaToken('')"
      >
        {{ 'ProductHomePageVisa:CheckEligibilityButton' | translate }}
      </button>

      <h4 *ngIf="!preloginHomepage">{{ (customVariables$ | async)?.eligibility_page_instruction2 }}</h4>

      <button
        mat-raised-button
        id="mid_button_login"
        tabindex="0"
        aria-label="Login"
        [color]="data?.buttonColor"
        *ngIf="!preloginHomepage"
        class="login-btn"
        (click)="onClick()"
        [innerHTML]="'LoginFormComponent:LoginButton' | translate"
      ></button>
    </mat-card>
  </div>
</section>
